/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Renders the case_studies.outcomes jsonb column as a three-column
 * table: metric / before / after. Shape:
 *   [{ metric: "...", before: "...", after: "..." }, ...]
 */

import React from 'react';

const OutcomesTable = ({ outcomes }) => {
  if (!Array.isArray(outcomes) || outcomes.length === 0) {
    return (
      <p className="text-sm italic text-brand-muted2">Outcomes pending.</p>
    );
  }

  return (
    <div className="overflow-x-auto border border-brand-border rounded-brandCard">
      <table className="min-w-full text-sm">
        <thead className="bg-brand-bgOff">
          <tr>
            <th className="text-left px-4 py-3 font-semibold text-brand-text">
              Metric
            </th>
            <th className="text-left px-4 py-3 font-semibold text-brand-text">
              Before
            </th>
            <th className="text-left px-4 py-3 font-semibold text-brand-text">
              After
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-brand-border">
          {outcomes.map((row, i) => (
            <tr key={i} className="bg-white">
              <td className="px-4 py-3 text-brand-text font-medium">
                {row.metric || '—'}
              </td>
              <td className="px-4 py-3 text-brand-muted">
                {row.before || '—'}
              </td>
              <td className="px-4 py-3 text-brand-green font-semibold">
                {row.after || '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OutcomesTable;
